import { Box, Flex, Skeleton } from '@chakra-ui/react'

const BORDER_COLOR = '#EAEAEB'
const SKELETON_COUNT = 4
const LINE_WIDTHS = ['100%', '100%', '38%']

const bone = {
    startColor: '#F3F3F3',
    endColor: '#E8E8E8',
    borderRadius: '4px',
}

const mobileCard = '@media (max-width: 639px)'
const phoneCard = '@media (max-width: 480px)'

const NewsCardSkeleton = (): JSX.Element => (
        <Flex
            h={'160px'}
            border={'1px solid'}
            borderColor={BORDER_COLOR}
            borderRadius={'8px'}
            overflow={'hidden'}
            bg={'white'}
            sx={{
                [mobileCard]: {
                    flexDirection: 'column',
                    height: 'auto',
                },
                [phoneCard]: {
                    height: 'auto',
                },
            }}
        >
            <Skeleton
                w={'320px'}
                h={'full'}
                flexShrink={0}
                borderRadius={0}
                startColor={'#F3F3F3'}
                endColor={'#E8E8E8'}
                sx={{
                    [mobileCard]: {
                        order: 0,
                        width: '100%',
                        height: 'calc(392px * 2 / 3)',
                        flex: '0 0 auto',
                    },
                    [phoneCard]: {
                        height: '165px',
                        flex: '0 0 auto',
                    },
                }}
            />
            <Flex
                direction={'column'}
                flex={1}
                justify={'center'}
                gap={'10px'}
                px={'16px'}
                py={'20px'}
                sx={{
                    [mobileCard]: { order: 1, flex: '0 0 auto', height: 'auto' },
                }}
            >
                <Skeleton w={'72%'} h={'24px'} {...bone} />
                {LINE_WIDTHS.map((width, index) => (
                    <Skeleton key={index} h={'12px'} w={width} {...bone} />
                ))}
            </Flex>
        </Flex>
)

const NewsListSkeleton = ({ count = SKELETON_COUNT, showDate = true }: { count?: number; showDate?: boolean }): JSX.Element => (
    <Flex direction={'column'} gap={'20px'} w={'full'} pb={'24px'} aria-busy={'true'} aria-label={'Loading news'}>
        {showDate ? <Skeleton h={'20px'} w={'64px'} {...bone} /> : null}
        {Array.from({ length: count }).map((_, index) => (
            <NewsCardSkeleton key={index} />
        ))}
    </Flex>
)

export default NewsListSkeleton
